module.exports = __webpack_public_path__ + "static/media/desktop.7ffeeeb5.ini";